<template>
    <div>
    <section class="page-header page-header-light page-header-more-padding">
        <div class="container">
            <div class="row row-eq-height">
                <div class="col-lg-12 headerSectionContainer" style="padding-left: 0 !important;">
                    <h1>
                        {{ $t('views.booking.base.caption.title') }}
                        <span class="subsentence">{{ $t('views.booking.base.caption.subsentence') }}</span>
                    </h1>
                </div>
            </div>
        </div>
    </section>

    <div class="container">
        <div class="row">                        
            <div class="col-12">
                <ValidationObserver v-slot="{ invalid }">
                    <form>
                        <div class="form-row">
                            <div class="col-12">
                                <h3>{{ $t('views.booking.common.titles.booking') }}</h3>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col">
                                <StaticPriceResult  
                                    :startDate="selectedDates.start"
                                    :endDate="selectedDates.end"
                                    :adults="occupants.adults"
                                    :kids="occupants.kids"
                                    :listing="listing"
                                    :showListing="true">
                                </StaticPriceResult>
                            </div>
                        </div>

                        
                        <hr class="solid">

                        <div class="form-row">
                            <div class="col-md-12">
                                <h3>{{ $t('views.booking.common.titles.information') }}</h3>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-12">
                                <h4>{{ $t('views.booking.common.titles.personal') }}</h4>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-lg-6">
                                <label>{{ $t('common.generalities.firstName') }} *</label>
                                <ValidatedField rules="required">
                                    <input :disabled="loading" class="form-control" type="text" v-model="payload.firstName">
                                </ValidatedField>
                                
                            </div>
                            <div class="form-group col-lg-6">
                                <label>{{ $t('common.generalities.lastName') }} *</label>
                                <ValidatedField rules="required">
                                    <input :disabled="loading" class="form-control" type="text" v-model="payload.lastName">
                                </ValidatedField>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-lg-10">
                                <label>{{ $t('common.generalities.street') }} *</label>
                                <ValidatedField rules="required">
                                    <input :disabled="loading" class="form-control" type="text" v-model="payload.street">
                                </ValidatedField>
                            </div>
                            <div class="form-group col-lg-2">
                                <label>{{ $t('common.generalities.number') }} *</label>
                                <ValidatedField rules="required">
                                    <input :disabled="loading" class="form-control" type="text" v-model="payload.number">
                                </ValidatedField>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-lg-2">
                                <label>{{ $t('common.generalities.cap') }} *</label>
                                <ValidatedField rules="required">
                                    <input :disabled="loading" class="form-control" type="text" v-model="payload.cap">
                                </ValidatedField>
                            </div>
                            <div class="form-group col-lg-5">
                                <label>{{ $t('common.generalities.city') }} *</label>
                                <ValidatedField rules="required">
                                    <input :disabled="loading" class="form-control" type="text" v-model="payload.city">
                                </ValidatedField>
                            </div>
                            <div class="form-group col-lg-5">
                                <label>{{ $t('common.generalities.country') }} *</label>
                                <ValidatedField rules="required">
                                    <CountryDropdown v-model="payload.nation"></CountryDropdown>
                                </ValidatedField>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col-12">
                                <h4>{{ $t('views.booking.common.titles.contact') }}</h4>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-lg-4">
                                <label>{{ $t('common.generalities.phoneNumber') }} *</label>
                                <ValidatedField rules="required">
                                    <input :disabled="loading" class="form-control" type="tel" v-model="payload.phoneNumber">
                                </ValidatedField>
                            </div>
                            <div class="form-group col-lg-4">
                                <label>{{ $t('common.generalities.mobileNumber') }} *</label>
                                <input :disabled="loading" class="form-control" type="tel" v-model="payload.mobileNumber">
                            </div>
                            <div class="form-group col-lg-4">
                                <label>{{ $t('common.generalities.email') }} *</label>
                                <ValidatedField rules="required">
                                    <input :disabled="loading" class="form-control" type="email" v-model="payload.email">
                                </ValidatedField>
                            </div>
                        </div> 

                        <div class="form-row">
                            <div class="col-12">
                                <h4>{{ $t('views.booking.common.titles.moreDetails') }}</h4>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-lg-4">
                                <label>{{ $t('common.reservation.travelDates') }} *</label>
                                <PopperDatePicker
                                    :selectedDates.sync="selectedDates"
                                    :bookings="listing.bookings"
                                    ref="calendar"
                                >
                                    <ValidatedField rules="required">
                                        <input :disabled="loading" class="form-control"  :value="computeDateString">
                                    </ValidatedField>
                                </PopperDatePicker>
                                <!-- FIXME: Uncomment this once the prices have been brought back on the server, and the quote is calculated there -->
                                <!-- <div class="alert alert-warning" role="alert" v-if="priceChanged">
                                    <div class="d-flex w-100 align-items-center">
                                        <div class="w-100"><i class="fas fa-exclamation-triangle"></i>{{ $t('views.booking.common.text.priceChange') }}</div>
                                        <div class="flex-shrink-1">
                                            <i class="fas fa-window-close" @click="priceChanged = false" style="cursor: pointer; padding: 10px; margin: 0px"></i>
                                        </div>
                                    </div>
                                </div> -->
                                
                            </div>
                            <div class="form-group col-lg-4">
                                <label>{{ $t('common.reservation.numberOfAdults') }} *</label>
                                <ValidatedField rules="required|number">
                                    <Stepper
                                        v-model="occupants.adults"
                                        :minValue="1"
                                    />
                                </ValidatedField>
                            </div>
                            <div class="form-group col-lg-4">
                                <label>{{ $t('common.reservation.numberOfKids') }} *</label>
                                <Stepper
                                    v-model="occupants.kids"
                                    :minValue="0"
                                    :maxValue="settings.maxNumberOfKids"
                                />
                            </div>
                        </div> 
                        
                        <div class="form-row">
                            <div class="form-group col-2" v-for="i in occupants.kids" :key="i">
                                <label :key="i">{{ $t('common.reservation.ageOfKid') }} {{ i }} *</label>
                                <ValidatedField rules="required|double">
                                    <input :disabled="loading" class="form-control" :key="`kid_age_${i}`" v-model="payload.ages[i - 1]">
                                </ValidatedField>
                            </div>
                        </div>                  

                        <div class="form-row">
                            <div class="form-group col">
                                <label>{{ $t('views.booking.common.text.message' )}}</label>
                                <textarea maxlength="5000" rows="5" class="form-control" :disabled="loading"  v-model="payload.message"></textarea>
                            </div>
                        </div>

                        <hr class="solid">

                        <div class="form-row">
                            <div class="col-md-12">
                                <h3>{{ $t('views.booking.base.confirm.title') }}</h3>
                                <p>{{ $t('views.booking.base.confirm.text') }}</p>
                            </div>
                        </div>

                        <div class="form-row" style="margin-bottom: 20px">
                            <template v-if="!loading">
                                <!-- <div class="col-6">
                                    RECAPTCHA
                                </div> -->
                                <div class="col-12">
                                    <div class="d-flex justify-content-end">
                                        <!-- TODO: Add recaptcha -->
                                        <button class="btn btn-primary" :disabled="invalid || loading" @click.prevent="sendRequest">{{ $t('views.booking.base.sendRequest') }}</button>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <Spinner :message="$t('views.booking.base.sendingRequest')"></Spinner>
                            </template>
                            
                        </div>
                    </form>
                </ValidationObserver>
            </div>
        </div>
        <RenterContact :listing="listing"/>
    </div>
    </div>
</template>

<script>
import PriceResult from "@/components/level3/PriceResult";
import StaticPriceResult from "@/components/level3/StaticPriceResult";
import ListingCard from "@/components/level2/ListingCard";
import PopperDatePicker from "@/components/common/datepicker/PopperDatePicker";
import { mapState } from 'vuex';
import Spinner from "@/components/common/Spinner";
import ValidatedField from "@/components/common/ValidatedField";
import CountryDropdown from "@/components/common/CountryDropdown";
import Stepper from "@/components/common/Stepper";
import { ValidationObserver } from 'vee-validate';
import RenterContact from "@/components/level3/RenterContact";



export default {
    name: 'BookingView',
    components: {
        PriceResult,
        StaticPriceResult,
        ListingCard,
        PopperDatePicker,
        Spinner,
        ValidatedField,
        ValidationObserver,
        CountryDropdown,
        Stepper,
        RenterContact
    },
    watch: {
        selectedDates: {
            deep: true,
            handler: function(newVal, oldVal) {
                if (oldVal.start !== newVal.start || oldVal.end !== newVal.end) {
                    this.priceChanged = true;
                }
            }
        }
    },
    computed: {
        listing: function() {
            return this.$store.getters.getCurrentListing;
        },
        listingId: function() {
            return this.listing.id;
        },
        result: function() {
            return this.$store.getters.getOffer;
        },
        query: function() {
            return this.$store.getters.getQuery;
        },
        kidOptions: function() {
            let lst = [];
            for (let i = 0; i < this.settings.maxNumberOfKids; i++) {
                lst.push({
                    value: i,
                    text: "" + i
                });
            }

            return lst;
        },
        computeDateString: function() {
            if (this.selectedDates.start === undefined || this.selectedDates.end === undefined) {
                return undefined;
            }
            let startDate = this.$moment(this.selectedDates.start);
            let endDate = this.$moment(this.selectedDates.end);

            let format = "DD.MM.YYYY";

            return startDate.format(format) + " - " + endDate.format(format);
        },
        completedRecaptcha: function() {
            return false;
        }
    },
    methods: {
        sendRequest: function() {
            // Before we send it we need to modify a few things
            // Parse the ages
            this.payload.ages = this.payload.ages.map(el => parseInt(el));

            // Parse the number of adults
            this.payload.numberOfAdults = parseInt(this.occupants.adults);

            // Parse the number of adults
            this.payload.numberOfKids = parseInt(this.occupants.kids);

            // Truncate the array
            this.payload.ages.length = this.occupants.kids;

            // Add the dates
            this.payload.startDate = this.normalizeDate(this.query.selectedDates.start);
            this.payload.endDate = this.normalizeDate(this.query.selectedDates.end);

            let listingId = this.listing.id;

            this.loading = true;

            this.$http.post(`/listings/${listingId}/requests`, this.payload)
            .then(res => {
                let booking = res.data;

                // Push into storage
                this.$store.commit('setBookingRequestConfirmation', booking);

                this.$router.push(`/${this.listing.objectId}/booking/success`);
            }).catch(err => {
                console.log(err);
                this.$router.push(`/error`)
            }).finally(() => {
                this.loading = false;
            });
        }
    },
    created() {
        let currentDates = this.query.selectedDates;
        if (!this.isUndefined(currentDates)) {
            this.selectedDates.start = currentDates.start;
            this.selectedDates.end = currentDates.end;
            console.log("Dates have been set: " + JSON.stringify(this.selectedDates));
        }

        // Apply the occupants
        let occupants = {
            adults: this.query.numberOfAdults,
            kids: this.query.numberOfKids
        }

        if (!this.isUndefined(occupants) && !this.allFieldsAreUndefined(occupants)) {
            this.occupants.adults = occupants.adults;
            this.occupants.kids = occupants.kids;
            console.log("Occupants have been set: " + JSON.stringify(this.occupants));
        }
    },
    mounted() {
        // We need to set the different data structures for the kids
        this.payload.ages = new Array(this.settings.maxNumberOfKids);
        this.payload.numberOfKids = 0;
    },
    data() {
        return {
            loading: false,
            priceChanged: false,
            selectedDates: {
                start: undefined,
                end: undefined
            },
            occupants: {
                adults: 1,
                kids: 0
            },
            payload: {
                firstName: undefined,
                lastName: undefined,
                street: undefined,
                number: undefined,
                cap: undefined,
                city: undefined,
                nation: undefined,
                phoneNumber: undefined,
                mobileNumber: undefined,
                email: undefined,
                numberOfAdults: undefined,
                message: undefined,
                numberOfKids: undefined,
                ages: undefined
            },
            settings: {
                maxNumberOfKids: 15
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    h3 {
        margin-bottom: 20px;
    }

    #offer {
        margin-bottom: 15px;
    }
</style>